import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { Layout, PageLoader } from "./components";
import { useAuth } from "./contexts";
import { Dashboard, Login } from "./pages";

const PrivateRoute = () => {
  const { isAuthenticated, getUserIsLoading } = useAuth();

  if (getUserIsLoading) return <PageLoader />;

  if (isAuthenticated)
    return (
      <Layout>
        <Outlet />
      </Layout>
    );

  return <Navigate to="/" />;
};

const PublicRoute = () => {
  const { isAuthenticated, getUserIsLoading } = useAuth();

  if (getUserIsLoading) return <PageLoader />;

  if (isAuthenticated) return <Navigate to="/app" />;

  return <Login />;
};

export const App = () => {
  return (
    <Routes>
      <Route path="/" element={<PublicRoute />} />

      <Route path="app/*" element={<PrivateRoute />}>
        <Route index element={<Navigate to="/app/dashboard" />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="*" element={<Navigate to="/app/dashboard" />} />
      </Route>
    </Routes>
  );
};
